import { CurrStageData } from '@/lib/actions/getCurrStage.ts'

export default function getStageIdString(
  stage?: CurrStageData | null,
  fullNumber = true,
  showIfIsOnlyStage = false,
) {
  if (!stage) return

  if (stage.isTheOnlyStage && !showIfIsOnlyStage) return

  let shortString = ''

  if (stage.project?.stagePrefix) {
    shortString += stage.project.stagePrefix
  }

  if (stage.stageIndex) shortString += stage.stageIndex

  if (!fullNumber) return shortString

  let fullString = ''

  if (stage.project?.number) fullString += stage.project.number

  fullString = fullString + ' - ' + shortString

  return fullString
}
